
import service from '@/service/chat_api'
import r4ReportApiList from "../service/basic/r4ReportApiList";
import {api} from '@/service/api'
const myhost = myhostname;
const host = hostname;
const echarthost = echarthostname;

// 获取结算汇总金额
export function querySettleSumInfo(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getSettleSumInfo}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取退款金额汇总
export function queryRefundSumInfo(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getRefundSumInfo}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取获取商户信息
export function queryLegalInfo(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getLegalInfo}`, {
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取供应商id
export function querySupplierId(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${host}${r4ReportApiList.getSupplierId}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取已支付结算单
export function queryPayedSettle(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getPayedSettle}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取已支付结算单
export function queryPayedSettleDetail(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getPayedSettleDetail}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 待处理订单
export function queryBillOrder(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getBillOrder}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 待处理订单
export function queryUnsettledOrder(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getUnsettledOrder}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 退货列表
export function queryDeductedRefund(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getDeductedRefund}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 退货明细
export function queryDeductedRefundDetail(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getDeductedRefundDetail}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 未退货明细
export function queryUnDeductedRefundDetail(params = {}) {
  return new Promise((resolve, reject) => {
    service.get(`${myhost}${r4ReportApiList.getUnDeductedRefundDetail}`, {
      params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取发货总金额
export function queryDeliverGoodsTotalAmount(params = {}) {
  return new Promise((resolve, reject) => {
    api.get(`${echarthost}${r4ReportApiList.getDeliverGoodsTotalAmount}`,params).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

// 获取发货列表
export function queryDeliverGoodsList(params = {}) {
  return new Promise((resolve, reject) => {
    api.get(`${echarthost}${r4ReportApiList.getDeliverGoodsList}`, params).then(res => {
      resolve(res && res.data)
    }).catch(err => {
      reject(err)
    })
  })
}




// WEBPACK FOOTER //
// ./src/models/r4ReportModel.js